import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

const UserModalOrganizacija = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white p-3 rounded shadow-md w-1/4">
                <div className='flex justify-end mb-2'>
                    <button onClick={onClose} className="">
                        <XMarkIcon className="w-6 h-6" />
                    </button>
                </div>

                {children}
            </div>
        </div>
    );
};

export default UserModalOrganizacija;